import React, { Component } from "react";
import { withRouter } from "react-router";
import { Route, Switch } from "react-router-dom";

import Login from "../screens/Login/LoginContainer";
import ResetPassword from "../screens/Login/ResetPassword.jsx";
import ForgotPassword from "../screens/Login/ForgotPasswordForm.jsx";
import TaskContainer from "../screens/TaskPackages/TaskContainer.jsx";
import AuthRoute from "../app/AuthRoute.jsx";
import ServiceContainer from "../screens/ServiceRecordPackage/ServiceRecordContainer.jsx";
import EquipmentContainer from "../screens/EquipmentPackage/EquipmentContainer.jsx";
import NotificationContainer from "../screens/NotificationPackage/NotificationContainer.jsx";
import EmployeeContainer from "../screens/EmployeePackage/EmployeeContainer.jsx";
// import PaymentContainer from "../screens/PaymentPackage/PaymentContainer.jsx";
// import PaymentPlan from "../screens/PaymentPackage/PaymentPlan.jsx";
import BuildingContainer from "../screens/BuildingsPackage/BuildingContainer.jsx";
import ProfileContainer from "../screens/ProfileEdit/ProfileContainer.jsx";
import VehiclesContainer from "../screens/VehiclesPackages/VehiclesContainer.jsx";
// import PurshaseInvalidScreen from "./PurchaseInValidScreen.jsx";
import { connect } from "react-redux";
import AcitvityContainer from "../screens/ActivityPackage/AcitvityConatiner.jsx";
import AdminEmployeeContainer from "../screens/AdminPackage/AdminEmployeePackage/AdminEmployeeContainer.jsx";
import OwnerPerformancingData from "../screens/AdminPackage/OwnerPerformancingData.jsx";
import Nosubscription from "../screens/Login/Nosubscription.jsx";
import SafetyNotificationContainer from "../screens/SafetyNotificationPackage/SafetyNotificationContainer.jsx";

class NavigationRouter extends Component {
  render() {
    // const purchaseToken = AuthService.getPurchaseToken();
    // const isAuthenticated = purchaseToken !== "null";

    console.log("isactivity ", this.props.isExpriedValid);

    return (
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/login" exact component={Login} />
        <Route path="/ResetPassword" exact component={ResetPassword} />
        <Route path="/forgotPassword" exact component={ForgotPassword} />
        <Route path="/Nosubscription" exact component={Nosubscription} />

        <div className="dashboard">
          <AuthRoute userAccess={["1"]} path="/Tasks" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<TaskContainer />)} */}
            <TaskContainer />
          </AuthRoute>

          <AuthRoute userAccess={["1"]} path="/Services" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<ServiceContainer />)} */}

            <ServiceContainer />
          </AuthRoute>

          <AuthRoute userAccess={["1"]} path="/Equipment" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<TaskContainer />)} */}

            <EquipmentContainer />
          </AuthRoute>

          <AuthRoute userAccess={["1", "3"]} path="/Notifications" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<EquipmentContainer />)} */}

            <NotificationContainer />
          </AuthRoute>

          <AuthRoute userAccess={["3", "1"]} path="/employee" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<EmployeeContainer /> )} */}
            <EmployeeContainer />
          </AuthRoute>

          <AuthRoute userAccess={["3"]} path="/Admin-Employee" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<EmployeeContainer /> )} */}
            <EmployeeContainer isAdmin={true} />
          </AuthRoute>

          <AuthRoute userAccess={["1"]} path="/Buildings" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (  <BuildingContainer />)} */}

            <BuildingContainer />
          </AuthRoute>

          {/* <AuthRoute path="/payments" exact>
          {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : ( <PaymentContainer />)}
            
            <PaymentContainer />
          </AuthRoute> */}

          {/* <AuthRoute path="/PaymentPlan" exact>
          {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : ( <PaymentPlan />)}
          
            <PaymentPlan />
          </AuthRoute> */}

          <AuthRoute userAccess={["1", "3"]} path="/editprofile" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<ProfileContainer />)} */}

            <ProfileContainer />
          </AuthRoute>

          <AuthRoute userAccess={["1"]} path="/vehicles" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<VehiclesContainer />)} */}

            <VehiclesContainer />
          </AuthRoute>
          <AuthRoute userAccess={["1"]} path="/Activity" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<VehiclesContainer />)} */}

            <AcitvityContainer />
          </AuthRoute>

          <AuthRoute userAccess={["3"]} path="/Employers" exact>
            <AdminEmployeeContainer />
          </AuthRoute>

          <AuthRoute userAccess={["3"]} path="/Admin-Content" exact>
            {/* {this.props.isExpriedValid === -2 ? (<PurshaseInvalidScreen /> ) : (<TaskContainer />)} */}
            <OwnerPerformancingData />
          </AuthRoute>

          <AuthRoute userAccess={["1"]} path="/safety-notification">
            <SafetyNotificationContainer />
          </AuthRoute>
        </div>

        <Route path="*" component={Login} />
      </Switch>
    );
  }
}

const mapStateToProps = function (state) {
  console.log("state in heree in here", state.expiredDate.expiredDate);
  return {
    isExpriedValid: state.expiredDate.expiredDate,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {};
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavigationRouter)
);
